import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Disclosure() {
  const navigate = useNavigate();

  return (
    <div className="disclosure-screen">
      <div className="disclosure-glow" aria-hidden="true" />
      <div className="disclosure-pattern" aria-hidden="true" />

      <main className="disclosure-panel">
        <p className="brand-eyebrow">Nutanix × KubeCon</p>
        <h1 className="brand-title">
          <span className="brand-q" aria-hidden="true">?</span>
          <span className="brand-title-text">Riddler&apos;s Funhouse</span>
        </h1>
        <p className="disclosure-lead">
          Pass all four challenges and earn a custom Challenge Coin.
        </p>
        <p className="disclosure-powered">
          Powered by <strong>Nutanix Kubernetes Platform</strong>
          <br />
          and <strong>Nutanix Enterprise AI</strong>.
        </p>

        <button
          type="button"
          className="btn-primary btn-play"
          onClick={() => navigate('/setup')}
        >
          Play
        </button>
      </main>
    </div>
  );
}
